import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  HostListener,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
// import { MsalService } from '@azure/msal-angular';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { finalize, forkJoin } from 'rxjs';
import { CanComponentDeactivate } from '../../../app/guards/can-deactivate.interface';
import { Messages, ValidationPatterns } from '../../../common/constants/messages';
import { stateCodenName } from '../../../common/constants/stateCode';
import { W9StateService } from '../../../common/services/W9StateService';
import { GooglePlacesService } from '../../../services/google-places.service';
import { UnsavedTrackingService } from '../../../services/unsaved-changes.service';
import { AccountSettingsRequest } from '../../models/company-request';
import { CompanyService } from '../../services/company.service';
import { HeaderService } from '../../services/header.service';
import { InvalidCharsPipe } from '../../../common/Helpers/invalid-chars.pipe';
import { SessionTimeoutService } from '../../../services/session-timeout.service';
import { ConfirmationService } from 'primeng/api';
import { VerificationStatusEnum } from '../../../common/enums/verification-status.enum';
import { GooglePlaceAutocompleteComponent } from '../../../common/components/google-place-autocomplete/google-place-autocomplete.component';

declare const grecaptcha: any;

@Component({
  selector: 'app-account-settings',
  standalone: true,
  imports: [CommonModule, TableModule, ReactiveFormsModule, NgxSpinnerModule, NgxMaskDirective, DialogModule, RouterModule, InvalidCharsPipe,GooglePlaceAutocompleteComponent],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.css'
})
export class AccountSettingsComponent
  implements CanComponentDeactivate, OnInit {

  signupForm!: FormGroup;
  statecodenname = stateCodenName;
  locListModalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  business: any;
  isSaving = false;
  companyId: number | null = null;
  primaryContactId: number | null = null;
  secondaryContactId: number | null = null;
  prefixList: any[] = [];
  suffixList: any[] = [];
  entityTypeList: any[] = [];
  industryList: any[] = [];
  stateList: any[] = [];  
  w9UploadedFileName = '';
  w9UploadedDate = null;
  w9Status = '';
  userList: any[] = [];
  w9List: any[] = [];
  loading = true;
  isIndustryOther = false;
  isEntityTypeOther = false;
  dialogType:
    | 'success'
    | 'unsaved'
    | 'error'
    | 'delete'
    | 'cannotDelete' = 'success';

  private resolveGuard!: (value: boolean) => void;
  userEmail = '';
  roleCode = '';
  canEdit = false;
  canDelete = false;
  payDayPerxId = '';
  nscId = '';
  readonly ValidationPatterns = ValidationPatterns;
  isSuperAdmin = false;
  isAccountDeleted = false;
  isW9NotUploadedOrRejected = false;
  private skipUnloadWarning = false;

  constructor(
    private fb: FormBuilder,
    private companyService: CompanyService,
    private googlePlacesService: GooglePlacesService,
    private http: HttpClient, private ngx: NgxSpinnerService,
    private unsavedService: UnsavedTrackingService,
    private router: Router,
    private headerService: HeaderService,
    private w9State: W9StateService,
    private route: ActivatedRoute,
    private sessionTimeout: SessionTimeoutService,
    private confirmationService: ConfirmationService
    // private msalService: MsalService    
  ) { }

  /* ================= INIT ================= */

 ngOnInit(): void {

  this.companyId = Number(this.route.snapshot.paramMap.get('id')) || null;

  if (this.companyId == null) {
    this.companyId = Number(sessionStorage.getItem('companyId')) || null;
  }

  this.userEmail = sessionStorage.getItem('email') || '';
  this.roleCode = sessionStorage.getItem('roleCode')?.toString() || '';

  if (this.roleCode === '1') {
    this.isSuperAdmin = true;
  }

  if (this.roleCode === '2' || this.roleCode === '1') {
    this.canEdit = true;
    this.canDelete = true;
  }

  if (this.companyId == null) {
    this.router.navigate(['/login']);
    return;
  }

  this.buildForm();

  this.loadDropdowns().subscribe({
    next: (res) => {

      this.entityTypeList = res.entityTypes;
      this.industryList = res.industries;
      this.stateList = res.states;
      this.getAccountSettings();

    },
    error: () => {

      this.dialogSummary = Messages.ErrorTitle;
      this.dialogMsg = Messages.ErrorInAPICall;
      this.locListModalDlg = true;

    }
  });
}

get businessInfoForm(): FormGroup {
  return this.signupForm.get('businessInfo') as FormGroup;
}

  verifyToken() {
    let companyName = sessionStorage.getItem('companyName');
    if (companyName) {
      this.headerService.setCompanyName(companyName);
      this.buildForm();

      this.loadDropdowns().subscribe({
        next: (res) => {

          this.entityTypeList = res.entityTypes;
          this.industryList = res.industries;
          this.stateList = res.states;

          this.getAccountSettings();

        },
        error: () => {

          this.dialogSummary = Messages.ErrorTitle;
          this.dialogMsg = Messages.ErrorInAPICall;
          this.locListModalDlg = true;

        }
      });
    }
    else {
      const returnUrl = this.router.url;
      console.log(returnUrl);
      this.router.navigate(
        ['/login'],
        {
          queryParams: {
            returnUrl: returnUrl
          }
        }
      );
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  handleRefresh(event: BeforeUnloadEvent) {

    if (this.skipUnloadWarning) {
      return;
    }

    if (sessionStorage.getItem('isLoggingOut') === 'true') {
      return;
    }

    if (this.unsavedService.hasChanges(this.signupForm)) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  getRole(roleCode: string): string {
    switch (roleCode) {
      case '1':
        return 'Super Admin';

      case '2':
        return 'Admin';

      case '3':
        return 'User';

      default:
        return '';
    }
  }

  canEditContact(userRoleCode: string) {
    let isEditable: boolean = false;

    switch (this.roleCode) {
      case '1':
        isEditable = true;
        break;
      case '2':
        if (userRoleCode == '2' || userRoleCode == '3')
          isEditable = true;
        break;
      case '3':
        if (userRoleCode == '3')
          isEditable = true;
        break;
    }

    return isEditable;
  }

  formatPhone(event: any, controlPath: string): void {
    let digits = event.target.value.replace(/\D/g, '').substring(0, 10);
    const parts = [];

    if (digits.length > 3) {
      parts.push(digits.substring(0, 3));
      if (digits.length > 6) {
        parts.push(digits.substring(3, 6));
        parts.push(digits.substring(6));
      } else {
        parts.push(digits.substring(3));
      }
    } else {
      parts.push(digits);
    }

    event.target.value = parts.join('-');
    this.signupForm.get(controlPath)?.setValue(digits);
  }
  /* ================= FORM ================= */

  buildForm(): void {
    this.signupForm = this.fb.group({
      businessInfo: this.fb.group({
        businessName: [
          '',
          [
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(ValidationPatterns.BUSINESS)
          ]
        ],
        industry: ['', Validators.required],
        industryOther: [
          '',
          [
            Validators.maxLength(100),
            Validators.pattern(ValidationPatterns.BUSINESS)
          ]
        ],
        entityType: [''],
        entityTypeOther: [
          '',
          [
            Validators.maxLength(100),
            Validators.pattern(ValidationPatterns.BUSINESS)
          ]
        ],
        employees: ['', Validators.pattern(ValidationPatterns.EMPLOYEES)],
        address1: [
          '',
          [
            Validators.required,
            Validators.pattern(ValidationPatterns.ADDRESS)
          ]
        ]
        ,
        address2: [
          '',
          [
            Validators.pattern(ValidationPatterns.ADDRESS)
          ]
        ]
        ,
        city: ['', [Validators.required, Validators.pattern(ValidationPatterns.CITY)]],
        state: ['', Validators.required],
        zip: [
          '',
          [
            Validators.required,
            Validators.pattern(ValidationPatterns.ZIP)
          ]
        ]
        ,
        phone: ['', [Validators.required, Validators.pattern(ValidationPatterns.PHONE)]],
        fax: ['', Validators.pattern(ValidationPatterns.PHONE)],
        email: ['', [Validators.required, Validators.email]],
        taxExempt: ['', Validators.required],
        employerIdentificationNumber: ['', Validators.pattern(ValidationPatterns.EIN)]
      })
    });
  }

  allowNumbersOnly(event: Event, controlPath: string) {
    const input = event.target as HTMLInputElement;

    // Only digits, max 10
    const numericValue = input.value.replace(/\D/g, '').slice(0, 10);
    input.value = numericValue;

    // Update FormControl
    const control = this.signupForm.get(controlPath);
    if (control) {
      control.setValue(numericValue.trim(), { emitEvent: false });
    }
  }
  onInput(event: any) {
    const input = event.target;

    // Keep digits only
    let value = input.value.replace(/\D/g, '');

    // Limit to 6 digits
    value = value.slice(0, 6);

    input.value = value;
    this.signupForm.get('businessInfo.employees')?.setValue(value, { emitEvent: false });
  }


  /* ================= SUBMIT ================= */

  submit(): void {

    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      this.dialogSummary = Messages.ValidationTitle;
      this.dialogMsg = Messages.ValidationMessage;
      this.locListModalDlg = true;
      return;
    }

    this.updateCompany();
  }

  cancel(): void {
    this.router.navigate(['/home']);
  }

  canDeactivate(): Promise<boolean> | boolean {

    if (sessionStorage.getItem('isLoggingOut') === 'true') {
      return true;
    }

    if (!this.unsavedService.hasChanges(this.signupForm)) {
      return true;
    }

    this.dialogSummary = 'Unsaved Changes';
    this.dialogMsg =
      'You have unsaved changes. Are you sure you want to cancel? Your progress will be lost.';

    this.dialogType = 'unsaved';
    this.locListModalDlg = true;

    return new Promise<boolean>((resolve) => {
      this.resolveGuard = resolve;
    });
  }
  stayOnPage() {

    this.locListModalDlg = false;

    if (this.resolveGuard) {
      this.resolveGuard(false);
      this.resolveGuard = undefined as any;
    }
  }

  leavePage() {

    this.locListModalDlg = false;

    if (this.resolveGuard) {
      this.resolveGuard(true);
      this.resolveGuard = undefined as any;
    }
  }

  /* ================= API ================= */

  updateCompany(): void {
    this.ngx.show();
    this.isSaving = true;

    const businessInfo = this.signupForm.get('businessInfo') as FormGroup;

    const payload: AccountSettingsRequest = {
      companyId: this.companyId,
      companyName: businessInfo.value.businessName.trim(),
      industry: this.toNull(businessInfo.value.industry),
      industryOther: businessInfo.value.industryOther,
      entityType: this.toNull(businessInfo.value.entityType),
      entityTypeOther: businessInfo.value.entityTypeOther,
      numberOfEmployees: businessInfo.value.employees || null,
      address1: businessInfo.value.address1.trim(),
      address2: businessInfo.value.address2.trim(),
      city: businessInfo.value.city.trim(),
      state: businessInfo.value.state.trim() || null,
      zip: businessInfo.value.zip?.replace(/\D/g, ''),
      companyPhone: businessInfo.value.phone,
      companyEmail: businessInfo.value.email,
      companyFax: businessInfo.value.fax,
      taxExempt: this.toBoolean(businessInfo.value.taxExempt),
      employerIdentificationNumber: businessInfo.value.employerIdentificationNumber,
      payDayPerxId: this.payDayPerxId,
      nscId: this.nscId
    };

    this.companyService.updateAccountSettings(payload).subscribe({
      next: () => {
        this.ngx.hide();
        this.isSaving = false;
        this.getAccountSettings()

        // show dialog
        this.dialogSummary = Messages.SuccessTitle;
        this.dialogMsg = Messages.AccountSettingsSuccessMessage;
        this.locListModalDlg = true;
        this.dialogType = 'success';
        this.signupForm.markAsPristine();
        this.unsavedService.markSaved(this.signupForm);
        sessionStorage.setItem('companyName', payload.companyName);
        this.headerService.setCompanyName(payload.companyName);
      },
      error: (err) => {
        this.ngx.hide();
        this.isSaving = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.SaveFailedMessage;
        this.locListModalDlg = true;
      }
    });

  }
  okClickedV2() {
    this.locListModalDlg = false;

    if (this.isAccountDeleted) {
      this.ngx.show();

      const superAdminCompanyId = sessionStorage.getItem('superAdminCompanyId');

      if (!superAdminCompanyId) {
        this.sessionTimeout.logout();
        return;
      }

      // Restore Super Admin company
      sessionStorage.setItem('companyId', superAdminCompanyId);
      this.companyId = Number(superAdminCompanyId);

      // Reload account details
      this.companyService.getAccountSettings(Number(this.companyId)).subscribe({
        next: (d) => {

          // Update form (same logic as your getAccountSettings())
          const businessInfo = this.signupForm.get('businessInfo') as FormGroup;

          businessInfo.patchValue({
            businessName: d.companyName,
            industry: this.toEmpty(d.industry),
            industryOther: d.industryOther,
            entityType: this.toEmpty(d.entityType),
            entityTypeOther: d.entityTypeOther,
            employees: d.numberOfEmployees,
            address1: d.address1,
            address2: d.address2,
            city: d.city,
            state: this.toEmpty(d.state),
            zip: d.zip,
            phone: d.companyPhone,
            email: d.companyEmail,
            fax: d.companyFax,
            taxExempt: d.taxExempt
          });

          // Update session/header
          const companyName = businessInfo.get('businessName')?.value;

          sessionStorage.setItem('companyName', companyName);
          this.headerService.setCompanyName(companyName);

          this.isAccountDeleted = false;

          this.skipUnloadWarning = true;
          this.signupForm.markAsPristine();
          this.unsavedService.markSaved(this.signupForm);

          window.location.reload();
          this.ngx.hide();
        },
        error: () => {
          this.ngx.hide();
          //this.sessionTimeout.logout();
        }
      });
      this.ngx.hide();
      return;
    }
  }


  /* ================= HELPERS ================= */

  isFieldInvalid(path: string): boolean {
    const control = this.signupForm.get(path);
    return !!(control && control.invalid && control.touched);
  }

  displayFieldCss(path: string) {
    return { 'has-error': this.isFieldInvalid(path) };
  }

  toBoolean(value: string | boolean | null): boolean {
    return value === true || value === 'true';
  }

  getStateCode(stateName: string): string {
    const match = this.statecodenname.find(
      s => s.stateName.toLowerCase() === stateName.toLowerCase()
    );
    return match ? match.stateCode : '';
  }

  /* ================= DROPDOWNS ================= */
  loadDropdowns() {
    this.ngx.show();

    return forkJoin({
      entityTypes: this.companyService.getAllEntityTypes(),
      industries: this.companyService.getAllIndustries(),
      states: this.companyService.getAllStates()
    }).pipe(
      finalize(() => this.ngx.hide())
    );
  }

  // Account Settings
  getAccountSettings(): void {
    this.loading = true;
    this.companyService.getAccountSettings(Number(this.companyId)).subscribe(d => {
      this.w9List = [];
      this.business = d;
      this.payDayPerxId = d.payDayPerxId;
      this.nscId = d.nscId;
      const businessInfo = this.signupForm.get('businessInfo') as FormGroup;
      this.companyId = d.companyId;
      this.primaryContactId = d.primaryContactId;
      this.secondaryContactId = d.secondaryContactId;
      businessInfo.get('businessName')?.setValue(d.companyName);
      const industry = this.toEmpty(d.industry);

      businessInfo.get('industry')?.setValue(industry);

      businessInfo.get('industryOther')?.setValue(
        this.toEmpty(d.industryOther)
      );

      this.onIndustryChange(industry, false);
      const entityType = this.toEmpty(d.entityType);

      businessInfo.get('entityType')?.setValue(entityType);

      businessInfo.get('entityTypeOther')?.setValue(
        this.toEmpty(d.entityTypeOther)
      );

      this.onEntityTypeChange(entityType, false);
      businessInfo.get('employees')?.setValue(d.numberOfEmployees);
      businessInfo.get('address1')?.setValue(d.address1);
      businessInfo.get('address2')?.setValue(d.address2);
      businessInfo.get('city')?.setValue(d.city);
      businessInfo.get('state')?.setValue(this.toEmpty(d.state));
      businessInfo.get('zip')?.setValue(d.zip);
      businessInfo.get('phone')?.setValue(d.companyPhone);
      businessInfo.get('email')?.setValue(d.companyEmail);
      businessInfo.get('fax')?.setValue(d.companyFax);
      businessInfo.get('taxExempt')?.setValue(d.taxExempt);
      businessInfo.get('employerIdentificationNumber')?.setValue(d.employerIdentificationNumber);
      this.userList = d.contacts.filter((c: {
        isActive: boolean; contactTypeCode: string;
      }) => (c.contactTypeCode === '1' ||
        c.contactTypeCode === '2') && c.isActive === true
      );
      if (d.w9UploadedDate) {
        this.w9List.push(
          {
            w9UploadedDate: d.w9UploadedDate,
            w9Status: d.w9Status,
            w9UploadedFileName: d.w9FileName,
            w9FileUrl: d.w9FileName
          }
        );
      }
      this.w9Status = d.w9Status;
      this.w9UploadedDate = d.w9UploadedDate;
      this.w9UploadedFileName = d.w9FileName;
      this.loading = false;
      this.signupForm.patchValue({
        prefix: this.toEmpty(d.prefixCode),
        firstName: d.firstName,
        lastName: d.lastName,
        suffix: this.toEmpty(d.suffixCode),
        jobTitle: d.jobTitle,
        phone: d.contactPhone,
        phoneExt: d.contactPhoneExtension,
        fax: d.fax,
        email: d.email,
        roleCode: d.roleCode
      });
      this.signupForm.markAsPristine();
      this.unsavedService.registerForm(this.signupForm);
      if (!this.isW9NotUploadedOrRejected) {
        this.checkW9Status();
      }
    }
    );
  }

  deleteUserProfile(id: any) {
    this.companyService.deleteUserProfile(id).subscribe({
      next: (res) => {
        this.ngx.hide();
        this.isSaving = false;
        this.dialogSummary = Messages.SuccessTitle;
        this.dialogMsg = Messages.DeleteUserSuccessMessage;
        this.locListModalDlg = true;
        this.getAccountSettings();
      },
      error: (err) => {
        this.ngx.hide();
        this.isSaving = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.DeleteUserFailedMessage;
        this.locListModalDlg = true;
      }
    });
  }

  editUserProfile(id: any) {
    this.router.navigate(['/user-profile/' + id]);
  }

  addUserProfile() {
    this.router.navigate(['/user-profile']);
  }

   uploadW9() {
    this.router.navigate(['/w9-business-verification']);
  }

  welcomeUser(email: string) {
    this.companyService.sendWelcomeMail(email).subscribe({
      next: (res) => {
        this.ngx.hide();
        this.isSaving = false;
        this.dialogSummary = Messages.SuccessTitle;
        this.dialogMsg = `Success! Invitation sent to ${email}.`;
        this.locListModalDlg = true;
      },
      error: (err) => {
        this.ngx.hide();
        this.isSaving = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = `We ran into a problem delivering the invite to ${email}. Please check the email for typos and try again.`;
        this.locListModalDlg = true;
      }
    });
  }

  downloadFile(fileName: string) {
    const payload = {
      fileName: fileName,
      containerType: "3"
    }

    this.ngx.show();
    this.isSaving = true;

    this.companyService.downloadFile(payload)
      .subscribe(
        {
          next: (blob) => {
            this.ngx.hide();
            this.isSaving = false;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          },

          error: (err) => {
            this.ngx.hide();
            this.isSaving = false;
            this.dialogSummary = Messages.ErrorTitle;
            this.dialogMsg = "Download Failed";
            this.locListModalDlg = true;
          }
        });
  }

  onIndustryChange(value: string, resetOther: boolean = true): void {

    const selected = this.industryList.find(
      i => i.industryPk == value
    );

    // Do not modify the control if dropdown data isn't available yet
    if (!selected) {
      return;
    }

    this.isIndustryOther =
      selected.industryName?.trim().toLowerCase() === 'other';

    const otherIndustryControl =
      this.signupForm.get('businessInfo.industryOther');

    if (!otherIndustryControl) {
      return;
    }

    if (this.isIndustryOther) {

      otherIndustryControl.setValidators([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(ValidationPatterns.BUSINESS)
      ]);

      if (resetOther) {
        otherIndustryControl.setValue('');
      }

    } else {

      otherIndustryControl.clearValidators();

      if (resetOther) {
        otherIndustryControl.setValue('');
      }
    }

    otherIndustryControl.updateValueAndValidity();
  }

  onEntityTypeChange(value: string, resetOther: boolean = true): void {

    const selected = this.entityTypeList.find(
      e => e.entityTypePk == value
    );

    if (!selected) {
      return;
    }

    this.isEntityTypeOther =
      selected.entityTypeName?.trim().toLowerCase() === 'other';

    const otherEntityTypeControl =
      this.signupForm.get('businessInfo.entityTypeOther');

    if (!otherEntityTypeControl) {
      return;
    }

    if (this.isEntityTypeOther) {

      otherEntityTypeControl.setValidators([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(ValidationPatterns.BUSINESS)
      ]);

      if (resetOther) {
        otherEntityTypeControl.setValue('');
      }

    } else {

      otherEntityTypeControl.clearValidators();

      if (resetOther) {
        otherEntityTypeControl.setValue('');
      }
    }

    otherEntityTypeControl.updateValueAndValidity();
  }

  // Utitlity Functions
  toNull(value: any) {
    return value === '' || value === undefined ? null : value;
  }
  toEmpty(value: any) {
    return value === null || value === undefined ? '' : value;
  }
  formatPhoneNumber(value: string): string {
    const digits = value.replace(/\D/g, '');

    if (digits.length !== 10) {
      return value; // or return ''
    }

    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  goToReplaceW9(w9: any) {
    if (this.companyId !== null) {
      this.w9State.setCompanyId(this.companyId.toString());
      this.router.navigate(['/replace-w9']);
    }
  }


  deleteAccount(): void {

    // First check for unsaved changes
    if (this.unsavedService.hasChanges(this.signupForm)) {

      this.dialogSummary = 'Unsaved Changes';

      this.dialogMsg =
        'You have unsaved changes. Are you sure you want to continue? Your changes will be lost.';

      this.dialogType = 'unsaved';
      this.locListModalDlg = true;

      // When user chooses to leave, continue with delete validation
      this.resolveGuard = (confirmed: boolean) => {
        if (confirmed) {
          this.locListModalDlg = false;
          this.checkCanDeleteAccount();
        } else {
          this.locListModalDlg = false;
        }
      };

      return;
    }

    // No unsaved changes
    this.checkCanDeleteAccount();
  }


  private checkCanDeleteAccount(): void {
    this.ngx.show();
    if (this.companyId == null) {
      return;
    }

    this.companyService.canDeleteAccount(this.companyId).subscribe({

      next: (canDelete: boolean) => {

        if (canDelete) {

          this.ngx.hide();
          this.dialogSummary = 'Delete this account?';

          this.dialogMsg =
            'Are you sure you want to permanently delete this account? This action cannot be undone, and all associated users and data will be lost.';

          this.dialogType = 'delete';
          this.locListModalDlg = true;

        } else {
          this.ngx.hide();
          this.dialogSummary = 'Cannot delete account';

          this.dialogMsg =
            'This account cannot be deleted because it has pending or completed agreements associated with it. To protect financial and historical records, accounts with active or finalized contracts must remain in the system.';

          this.dialogType = 'cannotDelete';
          this.locListModalDlg = true;
        }
      }

    });
  }
  confirmDeleteAccount(): void {

    this.locListModalDlg = false;

    if (this.companyId == null) {
      return;
    }


    this.ngx.show();
    this.companyService.deleteAccount(this.companyId).subscribe({
      next: () => {
        this.ngx.hide();
        this.isAccountDeleted = true;
        this.dialogType = 'success';
        this.dialogSummary = Messages.SuccessTitle;
        this.dialogMsg = Messages.AccountDeletedSuccessMessage; // or your success text
        this.locListModalDlg = true;
      },

      error: () => {
        this.ngx.hide();
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.AccountDeletedFailedMessage;
        this.dialogType = 'error';
        this.locListModalDlg = true;
      }

    });

  }

  
  private checkW9Status(): void {

  if (!this.companyId) {
    return;
  }

  this.companyService.getW9(this.companyId.toString()).subscribe({

    next: (w9) => {

      // No W9 uploaded
      if (!w9) {
        this.isW9NotUploadedOrRejected = true;
        this.showW9Popup();
        return;
      }

      // W9 rejected
      if (Number(w9.verificationStatus) === VerificationStatusEnum.Rejected) {
        this.isW9NotUploadedOrRejected = true;
        this.showW9Popup();
      }
    },

    error: () => {
      // Optional: log error
    }

  });

}

private showW9Popup(): void {

  this.confirmationService.confirm({

    header: 'Complete Business Verification',

    message:
      'To continue with voucher setup, you’ll need to upload your business or organization’s IRS Form W-9 and provide your EIN for business verification.',

    acceptLabel: 'Start Business Verification',

    rejectLabel: 'Not Now',

    accept: () => {

      this.router.navigate(['/w9-business-verification']);

    },

    reject: () => {

      // Nothing required.
      // Popup closes automatically and user remains on Account Settings.

    }

  });

}
}
